import settings from '../../assets/settings.json';
import Cookies from 'js-cookie'

class FunctionFields {
  convertTonyaNameToId(props_obj){
    let tonya_id = '';
    for (let i = 0; i < props_obj.tonya_datas_2.length; i++) {
      let obj_tonya_name_f = props_obj.tonya_datas_2[i].tonya_name_f;
      if(obj_tonya_name_f==props_obj.table_tonya_label){
        tonya_id = Number(props_obj.tonya_datas_2[i].id);
        break
      }
    }

    return tonya_id;
  }




  saveStaffInOut(this_state, what_type){
    let api_url = settings.API_BASE_URL + 'save_staff_inout/' + '?token=' + this_state.auth_obj.token + '&name='+ this_state.auth_obj.name + '&what_type='+what_type
    //var Httpreq = new XMLHttpRequest();
    //Httpreq.open("GET", api_url, false);
    //Httpreq.send(null);
    //var response_obj = JSON.parse(Httpreq.responseText)['data'];
    navigator.sendBeacon(api_url, '');
    //console.dir(response_obj);
  }




  getAmountdiff(amount_fix, row, dataFixIdArray, cm_datas, table_tonya_label){

    for (let i = 0; i < cm_datas.length; i++) {
      if(row.JAN===cm_datas[i].JAN && row.cm_order_no===cm_datas[i].cm_order_no){
        let _hattyuu_how = cm_datas[i].hattyuu_howmany;
        let _zumi_how = cm_datas[i].hattyuu_zumi;
        let _hikiate_how = cm_datas[i].hikiate_howmany;
        let this_status = cm_datas[i].hattyuu_status_now;
        let _c = 0;
        if(this_status==='未発注'){
          _c =  _hattyuu_how ;
        }else if(this_status==='発注済'){
          _c = _zumi_how;
        }else if(this_status==='完了'){
          _c = _hikiate_how;
        }

        if(table_tonya_label!=='欠品'){
          amount_fix = amount_fix - _hattyuu_how;
        }else{
          amount_fix = amount_fix - _c;
        }
      }
    }

    return amount_fix;
  }



  getOverNumberInputText(this_data_obj, __data_fix, input_val, toast_array, kigou, re_array){
    console.dir(this_data_obj);
    let jan = this_data_obj.JAN;
    let cm_order_no = this_data_obj.cm_order_no;
    let this_tonya_name = this_data_obj.which_tonya;
    let text = '';

    for (let i = 0; i < __data_fix.length; i++) {
      if(__data_fix[i].JAN===jan && __data_fix[i].cm_order_no && __data_fix[i].which_tonya!==this_tonya_name && __data_fix[i].which_tonya!=='欠品'){
        let diff = __data_fix[i].hattyuu_howmany_fix-input_val+this_data_obj.hattyuu_howmany_fix;

        if(kigou==='-'){
          text = '過剰発注になる可能性発生！\n該当分の「発注した数」変更願います。';
        }else{
          text = '不足手配になる可能性発生！\n該当分の「発注した数」変更願います。';
        }
        
        text += '管理番号：'+cm_order_no+'　';
        text += 'JAN：'+jan+'　';
        text += '変更すべき対象問屋：'+__data_fix[i].which_tonya+'　';
        text += '入力すべき発注した数：'+diff;
        break;
      }
    }

    console.log('過剰発注ワーニング '+text);

    let re_toast_array = [];
    if(text!==''){
      let toast_obj = {};
      toast_obj['id'] = this_data_obj.id;
      toast_obj['text'] = text;
      if(toast_array.length===0){
        re_toast_array = [toast_obj];
      }else{
        re_array.push(toast_obj);
        re_toast_array = re_array;
      }
    }else{
      re_toast_array = re_array;
    }

    return re_toast_array;
  }



  getSyukkaCheckBoardTh(table_tonya_label, tonya_datas){
    let syukka_check_board_type = '';
    let th_elms = '';
    for (let index = 0; index < tonya_datas.length; index++) {
      if(tonya_datas[index].tonya_name_f===table_tonya_label){
        syukka_check_board_type = tonya_datas[index].ship_check_keyword;
        break;
      }
    }

    console.log('getSyukkaCheckBoardTh '+syukka_check_board_type);

    if(syukka_check_board_type==='JAN'){
      th_elms = '<th>JAN</th>';
    }else if(syukka_check_board_type==='JAN,KEY'){
      th_elms = '<th>JAN</th><th>KEY</th>';
    }else if(syukka_check_board_type==='KEY'){
      th_elms = '<th>KEY</th>';
    }else if(syukka_check_board_type==='型番,KEY'){
      th_elms = '<th>型番</th><th>KEY</th>';
    }else if(syukka_check_board_type==='型番,KEY,商品名'){
      th_elms = '<th>型番</th><th>KEY</th><th>商品名</th>';
    }else if(syukka_check_board_type==='発注番号,JAN'){
      th_elms = '<th>発注番号</th><th>JAN</th>';
    }else if(syukka_check_board_type==='発注番号,JAN,KEY'){
      th_elms = '<th>発注番号</th><th>JAN</th><th>KEY</th>';
    }else if(syukka_check_board_type==='発注番号,JAN,型番'){
      th_elms = '<th>発注番号</th><th>JAN</th><th>型番</th>';
    }else if(syukka_check_board_type==='発注番号,型番'){
      th_elms = '<th>発注番号</th><th>型番</th>';
    }else if(syukka_check_board_type==='発注番号,型番,カラー,サイズ'){
      th_elms = '<th>発注番号</th><th>型番</th><th>カラー</th><th>サイズ</th>';
    }else if(syukka_check_board_type==='発注番号,商品名'){
      th_elms = '<th>発注番号</th><th>商品名</th>';
    }

    return th_elms;
  }



  getSyukkaCheckBoardtype(table_tonya_label, tonya_datas, _jan, _item_type, _key, item_name, color, size, _cm, _hattyuu_no){
    let syukka_check_board_type = '';
    let td_elms = '';
    for (let index = 0; index < tonya_datas.length; index++) {
      if(tonya_datas[index].tonya_name_f===table_tonya_label){
        syukka_check_board_type = tonya_datas[index].ship_check_keyword;
        break;
      }
    }

    //console.log('syukka_check_board_type '+syukka_check_board_type);

    if(_item_type===undefined){
      _item_type = '';
    }
    if(item_name===undefined){
      item_name = '';
    }
    if(color===undefined){
      color = '';
    }
    if(size===undefined){
      size = '';
    }

    if(item_name.length>20){
      item_name = item_name.slice( 0, 21 );
    }


    if(syukka_check_board_type==='JAN'){
      td_elms = '<td>'+_jan+'</td>';
    }else if(syukka_check_board_type==='JAN,KEY'){
      td_elms = '<td>'+_jan+'</td><td>'+_key+'</td>';
    }else if(syukka_check_board_type==='KEY'){
      td_elms = '<td>'+_key+'</td>';
    }else if(syukka_check_board_type==='型番,KEY'){
      td_elms = '<td>'+_item_type+'</td><td>'+_key+'</td>';
    }else if(syukka_check_board_type==='型番,KEY,商品名'){
      td_elms = '<td>'+_item_type+'</td><td>'+_key+'</td><td>'+item_name+'</td>';
    }else if(syukka_check_board_type==='発注番号,JAN'){
      td_elms = '<td>'+_hattyuu_no+'</td><td>'+_jan+'</td>';
    }else if(syukka_check_board_type==='発注番号,JAN,KEY'){
      td_elms = '<td>'+_hattyuu_no+'</td><td>'+_jan+'</td><td>'+_key+'</td>';
    }else if(syukka_check_board_type==='発注番号,JAN,型番'){
      td_elms = '<td>'+_hattyuu_no+'</td><td>'+_jan+'</td><td>'+_item_type+'</td>';
    }else if(syukka_check_board_type==='発注番号,型番'){
      td_elms = '<td>'+_hattyuu_no+'</td><td>'+_item_type+'</td>';
    }else if(syukka_check_board_type==='発注番号,型番,カラー,サイズ'){
      td_elms = '<td>'+_hattyuu_no+'</td><td>'+_item_type+'</td><td>'+color+'</td><td>'+size+'</td>';
    }else if(syukka_check_board_type==='発注番号,商品名'){
      td_elms = '<td>'+_hattyuu_no+'</td><td>'+item_name+'</td>';
    }

    //console.log(td_elms);

    return td_elms;
  }



  convertDataHikiate(_jan, input_val, __data, __data_fix, dataFixIdArray, what_type){
    console.log('convertDataHikiate Function');
    console.log('引き当て数確認');
    let _val = 0;
    let _hikiate_howmany = 0;
    let isit_minus = false;
    let _loop_check = 0;
    let calc_val = input_val;
    let prev_calc_val = 0;
    let hikiatari_id_array = [];
    let hikiate_zero_id_array = [];
    

    //{__data.map((data, index)=>{
    for (let index = 0; index < __data.length; index++) {
      let isit_yoyaku = false;
      if(__data[index].JAN===_jan && isNaN(input_val)===false){
        console.log('HIT JAN ' + _jan+' order_no:'+String(__data[index].cm_order_no));
        console.dir(__data[index]);

        let this_db_id = __data[index].id;
        let index_at_fix_data = dataFixIdArray.indexOf(this_db_id);
        _hikiate_howmany = __data_fix[index_at_fix_data].hattyuu_zumi;
        console.log('input VS _hikiate_howmany ' + input_val+' '+_hikiate_howmany);

        if(calc_val>=0){
          calc_val = calc_val - _hikiate_howmany;
        }


        //if(__data[index].cm_item_name.indexOf('予約注文___') !== -1 && calc_val<0){ //確認ボタンで引き当て数変更する場合
        if(__data[index].cm_item_name.indexOf('予約注文___') !== -1 && __data[index].cm_item_name.indexOf('予約注文___01_') === -1 && calc_val<0){
          hikiate_zero_id_array.push(__data[index].id);
          isit_yoyaku = true;
        }

        //
        if(__data[index].cm_item_name.indexOf('予約注文___') !== -1 && __data[index].cm_item_name.indexOf('予約注文___01_') !== -1 && calc_val<0){
          hikiate_zero_id_array.push(__data[index].id);
          
        }


        //if(what_type==='submit'){
        //  if(isit_minus===false && input_val < _hikiate_howmany){
        //    _val = input_val;
        //    _loop_check = 1;
        //    isit_minus = true;
        //  }else if(input_val === _hikiate_howmany && calc_val>=0){
        //    _val = input_val;
        //    _loop_check = 2;
        //    isit_minus = true;
        //  }else if(calc_val<0){
        //    _val = 0;
        //    _loop_check = 3;
        //  }else{
        //    _val = _hikiate_howmany;
        //    isit_minus = true;
        //    _loop_check = 4;
        //  }
        //}else if(what_type==='change'){
          console.log('calc_val ' + calc_val+' isit_yoyaku:'+String(isit_yoyaku));
          if(isit_yoyaku && what_type==='submit_sheet'){
            _val = 0;
            _loop_check = 100;
          }else if(input_val===0){
            _val = input_val;
            _loop_check = 0;
          }else if(isit_minus===false && input_val <= _hikiate_howmany){
            _val = input_val;
            _loop_check = 10;
            isit_minus = true;
          }else if(input_val === _hikiate_howmany && calc_val>=0){
            _val = input_val;
            _loop_check = 11;
            isit_minus = true;
          }else if(calc_val<0 && prev_calc_val>=0){
            _val = _hikiate_howmany + calc_val;
            _loop_check = 12;
            isit_minus = true;
          }else if(calc_val<0){
            _val = 0;
            _loop_check = 13;
          }else{
            _val = _hikiate_howmany;
            isit_minus = true;
            _loop_check = 14;
          }
        //}

        //


        //console.log('_val(' + _loop_check + ') ' + _val);



        __data[Number(index)].hikiate_howmany = _val;
        __data_fix[index_at_fix_data].hikiate_howmany = _val;
        hikiatari_id_array.push( __data_fix[index_at_fix_data].id);
      }

      prev_calc_val = calc_val;
      
    }


    return [__data, __data_fix, hikiatari_id_array, hikiate_zero_id_array]
  }


  convertDataHikiateId(this_db_id, input_val, __data, __data_fix, dataFixIdArray){
    console.log('convertDataHikiateId Function');
    let hikiatari_id_array = [];
    let hikiate_zero_id_array = [];
    let index_at_fix_data = dataFixIdArray.indexOf(this_db_id);
    __data_fix[index_at_fix_data].hikiate_howmany = input_val;

    for (let index = 0; index < __data.length; index++) {
      if(__data[index].id===this_db_id && isNaN(input_val)===false){
        __data[index].hikiate_howmany = input_val;

        let _id = __data[index].id;
        let _index_at_fix_data = dataFixIdArray.indexOf(_id);
        hikiatari_id_array.push( __data_fix[_index_at_fix_data].id);
      }
    }
    return [__data, __data_fix, hikiatari_id_array, hikiate_zero_id_array]
  }


  convertDataSyukkabiId(this_db_id, input_val, __data, __data_fix, dataFixIdArray){
    let index_at_fix_data = dataFixIdArray.indexOf(this_db_id);
    __data_fix[index_at_fix_data].when_syukka = input_val;

    for (let index = 0; index < __data.length; index++) {
      if(__data[index].id===this_db_id && isNaN(input_val)===false){
        __data[index].when_syukka = input_val;
      }
    }

    return [__data, __data_fix]
  }



  convertDataSyukkabi(_jan, input_val, __data, __data_fix, dataFixIdArray, what_type){
    if(what_type==='change'){
      for (let index = 0; index < __data.length; index++) {
        if(__data[index].JAN===_jan){
          console.log('HIT JAN');
          console.log(input_val);
  
          let this_db_id = __data[index].id;
          let index_at_fix_data = dataFixIdArray.indexOf(this_db_id);
          __data[Number(index)].when_syukka = input_val;
          __data_fix[index_at_fix_data].when_syukka = input_val;
  
        }
      }  
    }else if(what_type==='all'){
      for (let index = 0; index < __data.length; index++) {
        let this_db_id = __data[index].id;
        let index_at_fix_data = dataFixIdArray.indexOf(this_db_id);
        __data[Number(index)].when_syukka = input_val;
        __data_fix[index_at_fix_data].when_syukka = input_val;
      }    
    }else if(what_type==='add_date'){
      for (let index = 0; index < __data.length; index++) {
        let this_db_id = __data[index].id;
        let index_at_fix_data = dataFixIdArray.indexOf(this_db_id);
        __data[Number(index)].when_syukka = input_val;
        __data_fix[index_at_fix_data].when_syukka = input_val;
      }    
    }


    return [__data, __data_fix]
  }





  checkUrlQuery(params){
    let which_url = '';
    let query = '';
    let add_text = '';

    if(params.get('jan')===null){
      which_url = 'normal';
    }else{
      which_url = 'search';
      let staff_name = params.get('name');
      let staff_token = params.get('token');
      let tonya_name = params.get('tonya_name');
      let phase = params.get('phase');
      let hattyuu_no = params.get('hattyuu_no');
      let cm_order_no = params.get('cm_order_no');
      let updated_at_from = params.get('updated_at_from');
      let updated_at_to = params.get('updated_at_to');
      let jan = params.get('jan');
      let deli_limit = params.get('deli_limit');
      let hattyuu_stattus = params.get('hattyuu_stattus');
      let order_key = params.get('order_key');

      //tonya_name = encodeURI(tonya_name);
      query = `?name=${staff_name}
        &token=${staff_token}
        &tonya_name=${tonya_name}
        &phase=${phase}
        &updated_at_from=${updated_at_from}
        &updated_at_to=${updated_at_to}
        &deli_limit=${deli_limit}
        &jan=${jan}
        &cm_order_no=${cm_order_no}
        &hattyuu_stattus=${hattyuu_stattus}
        &order_key=${order_key}
        &hattyuu_no=${hattyuu_no}`

      query = query.replace(/\s+/g, '')





      if(hattyuu_no!==null && hattyuu_no!=='all'){
        add_text = '発注No.'+hattyuu_no;
      }
      if(order_key!==null && order_key!=='all'){
        if(add_text!==''){
          add_text = add_text+'　'+ 'KEY:'+order_key;
        }else{
          add_text = 'KEY:'+order_key;
        }
      }
      if(jan!==null && jan!=='all'){
        if(add_text!==''){
          add_text = add_text+'　'+ 'JAN:'+jan;
        }else{
          add_text = 'JAN:'+jan;
        }
      }
      if(cm_order_no!==null && cm_order_no!=='all'){
        if(add_text!==''){
          add_text = add_text+'　'+ '管理番号:'+cm_order_no;
        }else{
          add_text = '管理番号:'+cm_order_no;
        }
      }


    }

    console.log('which_url:'+which_url+' query:'+query+' add_text:'+add_text );
    return([which_url, query, add_text]);
  }




  // 欠品時　受注数-発注数　正しく表示する用
  getHattyuuVal(dataArray, cm_order_no, meisai_gyou, jan){
    //console.log( cm_order_no+String(meisai_gyou));
    let _hattyuu_val = 0;
    let multi_row = false;
    let prev_no = '';
    let prev_jan = '';
    for (let i = 0; i < dataArray.length; i++) {
      if(dataArray[i].cm_order_no===cm_order_no && dataArray[i].JAN===jan){
        _hattyuu_val = _hattyuu_val + (dataArray[i].hattyuu_howmany + dataArray[i].hattyuu_zumi );
      }
      //console.log(cm_order_no+String(meisai_gyou)+'-');
      if (cm_order_no+String(meisai_gyou)+'-1'===dataArray[i].order_key) {
        multi_row = true;
      }else if (cm_order_no+String(meisai_gyou)+'-2'===dataArray[i].order_key) {
        multi_row = true;
      }else if (cm_order_no+String(meisai_gyou)+'-3'===dataArray[i].order_key) {
        multi_row = true;
      }else if (cm_order_no+String(meisai_gyou)+'-4'===dataArray[i].order_key) {
        multi_row = true;
      }else if (cm_order_no+String(meisai_gyou)+'-5'===dataArray[i].order_key) {
        multi_row = true;
      }

      if( multi_row===true && prev_no!==dataArray[i].cm_order_no && prev_jan!==dataArray[i].JAN){
        break;
      }

      //if(i>0){
      //  console.log(dataArray[i-1].cm_order_no+' '+cm_order_no)
      //  if(dataArray[i-1].cm_order_no===cm_order_no && dataArray[i-1].JAN===jan){
      //    multi_row = true;
      //  }
      //}

      prev_no = dataArray[i].cm_order_no;
      prev_jan = dataArray[i].JAN;
    }
    return [_hattyuu_val, multi_row];
  }


  getJanInfo(auth_obj, jan){
    let api_url = settings.API_BASE_URL + 'hattyuu_jan_info/' + '?token=' + auth_obj.token + '&name='+ auth_obj.name +'&jan=' + jan
    //console.log(api_url);
    var Httpreq = new XMLHttpRequest();
    Httpreq.open("GET", api_url, false);
    Httpreq.send(null);
    var response_obj = JSON.parse(Httpreq.responseText)['data'];
    //console.dir(response_obj);
    return response_obj.obj;
  }


  getJanNextInfo(auth_obj, jan){
    let api_url = settings.API_BASE_URL + 'hattyuu_jan_next_info/' + '?token=' + auth_obj.token + '&name='+ auth_obj.name +'&jan=' + jan
    //console.log(api_url);
    var Httpreq = new XMLHttpRequest();
    Httpreq.open("GET", api_url, false);
    Httpreq.send(null);
    var response_obj = JSON.parse(Httpreq.responseText)['data'];
    //console.dir(response_obj);
    return response_obj.obj;
  }


  calcHattyuuHowmany(__data){
    let re_hattyuu_howmany = 0;
    for (let i = 0; i < __data.length; i++) {
      re_hattyuu_howmany = re_hattyuu_howmany + (__data[i].hattyuu_howmany);
    }

    return re_hattyuu_howmany;
  }


  calcHikiateHowmany(__data){
    let re_hikiate_howmany = 0;
    for (let i = 0; i < __data.length; i++) {
      re_hikiate_howmany = re_hikiate_howmany + (__data[i].hikiate_howmany);
    }

    return re_hikiate_howmany;
  }


  convertDate(what_type, hattyuu_date){
    //console.log(hattyuu_date);
    //2023-05-16T05:36:26
    var dateObject = new Date(hattyuu_date);
    let today_str ='';
    today_str = (dateObject.getMonth()+1) + '/' + dateObject.getDate() +' '+dateObject.getHours().toString().padStart(2, '0')+':'+dateObject.getMinutes().toString().padStart(2, '0') ;

    if(what_type==='jan-info'){
      today_str = dateObject.getFullYear() +'/'+ (dateObject.getMonth()+1) + '/' + dateObject.getDate() ;
    }else if(what_type==='syukka-date'){
      today_str = dateObject.getFullYear() +'-'+ String(dateObject.getMonth()+1).padStart(2, '0') + '-' + String(dateObject.getDate()).padStart(2, '0') ;
    }

    //console.log(today_str);
    return today_str;
  }

  reorder(auth_obj, db_ids){
    console.log('reorder');

    let api_url = settings.API_BASE_URL + settings.API_REORDER_URL + '?token=' + auth_obj.token + '&name='+ auth_obj.name

    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ data: db_ids })
    };
    let res = fetch(api_url, requestOptions)
        .then(response => response.json())
        .then(data => {
          //console.log(data);
          return data.data.obj
        })
        .catch(err => {
          console.log(err)
          return err
        })

    return res;
  }



  getHistory(auth_obj, jan, cm_order_no){
    let api_url = settings.API_BASE_URL + settings.API_GET_HATTYUU_HISTORY_URL + '?token=' + auth_obj.token + '&name='+ auth_obj.name +'&jan=' + jan+'&cm_order_no='+cm_order_no
    var Httpreq = new XMLHttpRequest();
    Httpreq.open("GET", api_url, false);
    Httpreq.send(null);
    var response_obj = JSON.parse(Httpreq.responseText)['data'];
    return response_obj['obj'];

  }


  // Select Tonya Elem Change Event & Click Tonya No. in Board Component
  ChangeSelectTonya(where_event, this_type, this_state, args){
    //console.dir(this_state.cm_datas);
    console.dir(this_state.dataArray);
    //console.log(tonya_name_f);
    //console.log(this_state.table_phase_label);
    let tonya_name_f = '';
    let phase_name = '';
    let hattyuu_status = '';

    if(this_type==='tonya_label'){
      tonya_name_f = args;
      phase_name = this_state.table_phase_label;
      hattyuu_status = this_state.table_hattyuu_status_label;

    }else if(this_type==='phase'){
      tonya_name_f = this_state.table_tonya_label;
      phase_name = args;
      hattyuu_status = this_state.table_hattyuu_status_label;

    }else if(this_type==='hattyuu'){
      tonya_name_f = this_state.table_tonya_label;
      phase_name = this_state.table_phase_label;
      hattyuu_status = args;
    }

    if(tonya_name_f===undefined){
      tonya_name_f = 'all';
    }

    console.log('where_event:'+where_event+' tonya_name_f:'+this_state.table_tonya_label+' phase_name:'+this_state.table_phase_label+' hattyuu_status:'+this_state.table_hattyuu_status_label);
    console.log('where_event:'+where_event+' tonya_name_f:'+tonya_name_f+' phase_name:'+phase_name+' hattyuu_status:'+hattyuu_status);

    let newSelectArray = [];
    let howmany_amount = 0;
    let hattyuu_howmany = 0;
    let diff_counter = 0;
    //if(this_state.cm_datas===undefined){
    //  alert('該当なし（未発注）');
    //}

    let which_soart = 0;
    if(tonya_name_f==='all' && phase_name==='all' && hattyuu_status==='all'){
      which_soart = 1;
    }else if(tonya_name_f!=='all' && phase_name==='all' && hattyuu_status==='all'){
      which_soart = 2;
    }else if(tonya_name_f!=='all' && phase_name!=='all' && hattyuu_status==='all'){
      which_soart = 3;
    }else if(tonya_name_f!=='all' && phase_name!=='all' && hattyuu_status!=='all'){
      which_soart = 4;
    }else if(tonya_name_f==='all' && phase_name!=='all' && hattyuu_status==='all'){
      which_soart = 5;
    }else if(tonya_name_f==='all' && phase_name!=='all' && hattyuu_status!=='all'){
      which_soart = 6;
    }else if(tonya_name_f==='all' && phase_name==='all' && hattyuu_status!=='all'){
      which_soart = 7;
    }else if(tonya_name_f!=='all' && phase_name==='all' && hattyuu_status!=='all'){
      which_soart = 8;
    }else{
      which_soart = 9;
    }
    console.log('which_soart: '+String(which_soart));

    let search_key_list = [];
    let search_val_list = [];
    if(where_event==='search'){
      //console.log('SEARCH CHECK KEY WORD '+String(args));
      if(args!==undefined){
        for (let i = 0; i < args.length; i++) {
          for (var [key, value] of Object.entries(args[i])) {
            //console.log(`KEY is ${key}, VALUE is ${value}`);
            search_key_list.push(key);
            search_val_list.push(value);
          }
        }
        console.dir(search_key_list);
        console.dir(search_val_list);
      }

    }


    let _loop_check = '';
    let prev_jan= '';
    let prev_cm_order_no = '';

    for (let i = 0; i < this_state.cm_datas.length; i++) {
      //console.dir(this_state.cm_datas[i]);
      if(i!=0){
        prev_jan = this_state.cm_datas[i-1].JAN;
        prev_cm_order_no = this_state.cm_datas[i-1].cm_order_no;
      }


      if(where_event==='board'){
        _loop_check = 0;
        if(this_state.cm_datas[i].hattyuu_status_now==='未発注' && this_state.cm_datas[i].which_tonya===tonya_name_f){
          newSelectArray.push(this_state.cm_datas[i]);
          //if(this_state.cm_datas[i].cm_phase==='取り込み済み' || this_state.cm_datas[i].cm_phase==='住所不備'){
          if(this_state.cm_datas[i].hattyuu_status_now==='未発注'){ //0806
            //howmany_amount ++;
            //howmany_amount = howmany_amount + (this_state.cm_datas[i].amount); // 5/29 問屋Noクリック時、欠品ある場合数合わないので..
            howmany_amount = howmany_amount + (this_state.cm_datas[i].amount_fix);
            hattyuu_howmany = hattyuu_howmany + (this_state.cm_datas[i].hattyuu_howmany) + (this_state.cm_datas[i].hattyuu_zumi);

          }
        }
      }else if(where_event==='board_2'){
        _loop_check = 100;
        //if(this_state.cm_datas[i].hattyuu_status_now==='発注済' && this_state.cm_datas[i].which_tonya===tonya_name_f){ 0806
        if(this_state.cm_datas[i].hattyuu_status_now==='発注済' && this_state.cm_datas[i].which_tonya===tonya_name_f && this_state.hikiate_post_ids.includes(this_state.cm_datas[i].id)===false){
          newSelectArray.push(this_state.cm_datas[i]);
          //if(this_state.cm_datas[i].cm_phase==='取り込み済み' || this_state.cm_datas[i].cm_phase==='住所不備'){ // DEV 本当は発注済
            //howmany_amount ++;
            //howmany_amount = howmany_amount + (this_state.cm_datas[i].amount); // 5/29 問屋Noクリック時、欠品ある場合数合わないので..
          howmany_amount = howmany_amount + (this_state.cm_datas[i].amount_fix);
          hattyuu_howmany = hattyuu_howmany + (this_state.cm_datas[i].hattyuu_howmany) + (this_state.cm_datas[i].hattyuu_zumi);

          //}
        }
      }else if(where_event==='search'){
        if(this_state.isit_hattyuu_board===true){ //出荷確認の場合
          tonya_name_f = this_state.table_tonya_label;
          phase_name = this_state.table_phase_label;
          hattyuu_status = this_state.table_hattyuu_status_label;
          //console.log('check search '+tonya_name_f+' '+phase_name+' '+hattyuu_status);
        }


        _loop_check = 200;
        let search_isit_add = false;
        for (let _i = 0; _i < search_key_list.length; _i++) {
          if(search_key_list[_i]==='発注No'){
            //console.log('fix:'+String(this_state.cm_datas[i].hattyuu_no)+'_input:'+ String(search_val_list[_i]));
            //if(String(this_state.cm_datas[i].hattyuu_no)===String(search_val_list[_i])){
            if( String(this_state.cm_datas[i].hattyuu_no).indexOf(String(search_val_list[_i]))!==-1 ){
              console.log('HIT_1');
              search_isit_add = true;
            }
          }
          if(search_key_list[_i]==='KEY'){
            //if(this_state.cm_datas[i].order_key===search_val_list[_i]){
            if(String(this_state.cm_datas[i].order_key).indexOf(String(search_val_list[_i]))!==-1 ){
              console.log('HIT_2');
              search_isit_add = true;
            }
          }
          if(search_key_list[_i]==='JAN'){
            if(this_state.cm_datas[i].JAN===search_val_list[_i]){
              console.log('HIT_3');
              search_isit_add = true;
            }
          }
          if(search_key_list[_i]==='管理番号'){
            if(this_state.cm_datas[i].cm_order_no===search_val_list[_i]){
              console.log('HIT_4');
              search_isit_add = true;
            }
          }
        }

        //console.log('search_isit_add '+String(search_isit_add));

        if(search_isit_add===true){
          console.log('SEARCH 1');
          //newSelectArray.push(this_state.cm_datas[i]);
          // 0806
          if(this_state.isit_hattyuu_board===true){ // 出荷確認画面、検索、発注ずみのみでソート. 出荷確認リストの絞り込みができない
            if(this_state.cm_datas[i].hattyuu_status_now==='発注済' && this_state.cm_datas[i].which_tonya===tonya_name_f){
              newSelectArray.push(this_state.cm_datas[i]);
              console.log('push check 1');
            }
          }else{
            newSelectArray.push(this_state.cm_datas[i]);
          }

          howmany_amount = howmany_amount + (this_state.cm_datas[i].amount_fix);
          hattyuu_howmany = hattyuu_howmany + (this_state.cm_datas[i].hattyuu_howmany) + (this_state.cm_datas[i].hattyuu_zumi);

        }else if(search_key_list.length===0){ // 検索　空 の時
          console.log('SEARCH 2');
          newSelectArray.push(this_state.cm_datas[i]);
          howmany_amount = this_state.howmany_order_fix;
          hattyuu_howmany = hattyuu_howmany + (this_state.cm_datas[i].hattyuu_howmany) + (this_state.cm_datas[i].hattyuu_zumi);
        }else{
          console.log('SEARCH 3');
        }

      }else if(where_event==='checkbox_submit'){
        _loop_check = 300;
        newSelectArray = this_type;
        howmany_amount = howmany_amount + (this_state.cm_datas[i].amount_fix);
        hattyuu_howmany = hattyuu_howmany + (this_state.cm_datas[i].hattyuu_howmany) + (this_state.cm_datas[i].hattyuu_zumi);

      }else if(args==='yoyaku'){ // 
        _loop_check = 300;

        if(this_state.cm_datas[i].hattyuu_status_now==='発注済' && this_state.cm_datas[i].cm_item_name.indexOf('予約注文___') !== -1){
          newSelectArray.push(this_state.cm_datas[i]);
          howmany_amount = howmany_amount + (this_state.cm_datas[i].amount);
          hattyuu_howmany = hattyuu_howmany + (this_state.cm_datas[i].hattyuu_howmany) + (this_state.cm_datas[i].hattyuu_zumi);
        }
      }else if(which_soart===1){
        _loop_check = 1;
        newSelectArray.push(this_state.cm_datas[i]);
        howmany_amount = this_state.howmany_order_fix;
        //hattyuu_howmany = this_state.howmany_order_fix_2; // 5/29 change
        hattyuu_howmany = hattyuu_howmany + (this_state.cm_datas[i].hattyuu_howmany) + (this_state.cm_datas[i].hattyuu_zumi);
      }else if(which_soart===2){
        _loop_check = 2;
        if(this_state.cm_datas[i].which_tonya===tonya_name_f){
          newSelectArray.push(this_state.cm_datas[i]);
          //if(this_state.cm_datas[i].cm_phase==='取り込み済み' || this_state.cm_datas[i].cm_phase==='住所不備'){
          //if(this_state.cm_datas[i].hattyuu_status_now==='未発注'){
            howmany_amount = howmany_amount + (this_state.cm_datas[i].amount_fix);
            hattyuu_howmany = hattyuu_howmany + (this_state.cm_datas[i].hattyuu_howmany) + (this_state.cm_datas[i].hattyuu_zumi);
          //}

          if(prev_cm_order_no===this_state.cm_datas[i].cm_order_no && prev_jan===this_state.cm_datas[i].JAN){
            //console.log('GACHA');
            howmany_amount = howmany_amount - (this_state.cm_datas[i].amount_fix);
          }
        }
      }else if(which_soart===3){
        _loop_check = 3;
        if(this_state.cm_datas[i].which_tonya===tonya_name_f && this_state.cm_datas[i].cm_phase===phase_name){
          newSelectArray.push(this_state.cm_datas[i]);
          //if(this_state.cm_datas[i].cm_phase==='取り込み済み' || this_state.cm_datas[i].cm_phase==='住所不備'){
          //if(this_state.cm_datas[i].hattyuu_status_now==='未発注'){
            //howmany_amount ++;
            howmany_amount = howmany_amount + (this_state.cm_datas[i].amount);
            hattyuu_howmany = hattyuu_howmany + (this_state.cm_datas[i].hattyuu_howmany) + (this_state.cm_datas[i].hattyuu_zumi);
          //}
        }
      }else if(which_soart===4){
        _loop_check = 4;
        if(this_state.cm_datas[i].which_tonya===tonya_name_f && this_state.cm_datas[i].cm_phase===phase_name && this_state.cm_datas[i].hattyuu_status_now===hattyuu_status){
          newSelectArray.push(this_state.cm_datas[i]);
          //if(this_state.cm_datas[i].cm_phase==='取り込み済み' || this_state.cm_datas[i].cm_phase==='住所不備'){
          //if(this_state.cm_datas[i].hattyuu_status_now==='未発注'){
            //howmany_amount ++;
            howmany_amount = howmany_amount + (this_state.cm_datas[i].amount);
            hattyuu_howmany = hattyuu_howmany + (this_state.cm_datas[i].hattyuu_howmany) + (this_state.cm_datas[i].hattyuu_zumi);
          //}
        }
      }else if(which_soart===5){
        _loop_check = 5;
        if(this_state.cm_datas[i].cm_phase===phase_name){
          newSelectArray.push(this_state.cm_datas[i]);
          //if(this_state.cm_datas[i].cm_phase==='取り込み済み' || this_state.cm_datas[i].cm_phase==='住所不備'){
          //if(this_state.cm_datas[i].hattyuu_status_now==='未発注'){
            //howmany_amount ++;
            howmany_amount = howmany_amount + (this_state.cm_datas[i].amount);
            hattyuu_howmany = hattyuu_howmany + (this_state.cm_datas[i].hattyuu_howmany) + (this_state.cm_datas[i].hattyuu_zumi);
          //}
        }
      }else if(which_soart===6){
        _loop_check = 6;
        if(this_state.cm_datas[i].cm_phase===phase_name && this_state.cm_datas[i].hattyuu_status_now===hattyuu_status){
          newSelectArray.push(this_state.cm_datas[i]);
          //if(this_state.cm_datas[i].cm_phase==='取り込み済み' || this_state.cm_datas[i].cm_phase==='住所不備'){
          //if(this_state.cm_datas[i].hattyuu_status_now==='未発注'){
            //howmany_amount ++;
            howmany_amount = howmany_amount + (this_state.cm_datas[i].amount);
            hattyuu_howmany = hattyuu_howmany + (this_state.cm_datas[i].hattyuu_howmany) + (this_state.cm_datas[i].hattyuu_zumi);
          //}
        }
      }else if(which_soart===7){
        _loop_check = 7;
        if(this_state.cm_datas[i].hattyuu_status_now===hattyuu_status){
          newSelectArray.push(this_state.cm_datas[i]);
          //if(this_state.cm_datas[i].cm_phase==='取り込み済み' || this_state.cm_datas[i].cm_phase==='住所不備'){
          //if(this_state.cm_datas[i].hattyuu_status_now==='未発注'){
            //howmany_amount ++;
            howmany_amount = howmany_amount + (this_state.cm_datas[i].amount);
            hattyuu_howmany = hattyuu_howmany + (this_state.cm_datas[i].hattyuu_howmany) + (this_state.cm_datas[i].hattyuu_zumi);
          //}
        }else{
          if(this_state.cm_datas[i].amount_fix===0){
            console.log('ADD');
            diff_counter = diff_counter + (this_state.cm_datas[i].hattyuu_zumi) ;
          }
          //console.log('how hattyuu zumi('+this_state.cm_datas[i].order_key+'):'+String(this_state.cm_datas[i].hattyuu_zumi));
        }

      }else if(which_soart===8){
        _loop_check = 8;
        if(this_state.cm_datas[i].which_tonya===tonya_name_f && this_state.cm_datas[i].hattyuu_status_now===hattyuu_status){
          //console.dir(this_state.cm_datas[i]);
          newSelectArray.push(this_state.cm_datas[i]);
          //if(this_state.cm_datas[i].cm_phase==='取り込み済み' || this_state.cm_datas[i].cm_phase==='住所不備'){
          //if(this_state.cm_datas[i].hattyuu_status_now==='未発注'){
            //howmany_amount ++;
            howmany_amount = howmany_amount + (this_state.cm_datas[i].amount);
            hattyuu_howmany = hattyuu_howmany + (this_state.cm_datas[i].hattyuu_howmany) + (this_state.cm_datas[i].hattyuu_zumi);
          //}
        }

        

      }else{
        _loop_check = 9;
        newSelectArray = this_state.cm_datas;
        howmany_amount = this_state.howmany_order_fix;
        hattyuu_howmany = this_state.howmany_order_fix_2;
      }

    }

    let isit_junban_check = false;
    var _c = 0;
    if(where_event==='search' && search_key_list.length===0){
      _c = 1;
      isit_junban_check = false;
    }else if(newSelectArray.length===0 || this_state.dataArray.length===0){
      _c = 2;
      isit_junban_check = false;
    }else if(_loop_check === 1 || _loop_check === 2 ){
      _c = 3;
      isit_junban_check = false;
    }else if(where_event==='board' || where_event==='board_2'){
      _c = 4;
      isit_junban_check = false;
    }else if(which_soart===8 && where_event==='paste_excel'){
      _c = 5;
      isit_junban_check = true;
    }else if(this_state.search_array!==undefined){
      _c = 6;
      isit_junban_check = true;
    }

    // 順番チェック 処理されることでリスト表示されない時がある、上の isit_junban_check で確認

    console.log('_C '+String(_c));
    console.dir(search_key_list);
    console.dir(newSelectArray);
    if(isit_junban_check===true){
    //if(isit_junban_check){
      console.log('順番チェック');
      // Loop は cm_datas, 表示中は dataArray 順番が変わる
      let re_array = [];
      //for (let i = 0; i < this_state.dataArray.length; i++) { // 連続検索すると該当無しになる
      for (let i = 0; i < this_state.cm_datas.length; i++) {
        for (let ii = 0; ii < newSelectArray.length; ii++) {
          //if(this_state.dataArray[i].id===newSelectArray[ii].id){
          //  re_array.push(this_state.dataArray[i]);
          if(this_state.cm_datas[i].id===newSelectArray[ii].id){
            re_array.push(this_state.cm_datas[i]);
            break;
          } 
        }
      }
      console.dir(re_array);
      newSelectArray = re_array;
    }


    //if(this_state.search_array!==undefined){
    if(this_state.search_array!==undefined && where_event!=='board_2'){ // 0806
      if(where_event!=='search' && this_state.search_array.length!==0){
        console.dir(newSelectArray);
        let search_key_list = [];
        let search_val_list = [];
        let re_array = [];
        for (let i = 0; i < this_state.search_array.length; i++) {
          for (var [key, value] of Object.entries(this_state.search_array[i])) {
            //console.log(`KEY is ${key}, VALUE is ${value}`);
            //search_key_list.push(key);
            //search_val_list.push(value);
  
            for (let ii = 0; ii < newSelectArray.length; ii++) {
              if(key==='管理番号'){
                if(newSelectArray[ii].cm_order_no===value){
                  re_array.push(newSelectArray[ii]);
                }
              }else if(key==='発注No'){
                if(newSelectArray[ii].hattyuu_no===value){
                  re_array.push(newSelectArray[ii]);
                }
              }else if(key==='KEY'){
                if(newSelectArray[ii].order_key===value){
                  re_array.push(newSelectArray[ii]);
                }
              }else if(key==='JAN'){
                if(newSelectArray[ii].JAN===value){
                  re_array.push(newSelectArray[ii]);
                }
              }
            }
          }
        }
  
        newSelectArray = re_array;
        console.dir(newSelectArray);
      }
    }




    console.log('_loop_check:'+String(_loop_check));
    //console.log(newSelectArray.length);
    console.log('howmany_amount:'+String(howmany_amount));
    console.log('hattyuu_howmany:'+String(hattyuu_howmany));
    console.log('diff_counter:'+String(diff_counter));
    return [newSelectArray, howmany_amount, hattyuu_howmany, which_soart, diff_counter]
  }


}

const addCmListFunction = new FunctionFields();

export { addCmListFunction };
